// Clipboard chip — v4 successor of v3's CopyToClipboardButton for the deliver
// tab (join / session code + join link affordances). Clipboard-only, no wire.
import { CopyLinear } from '@assessprep/icons/solar';
import { ComponentType, ReactNode, SVGProps } from 'react';
import { toast } from 'sonner';

import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { writeToClipboardPolyfill } from '@/lib/commonHelpers';

export interface CopyChipProps {
  copyValue: string;
  label: ReactNode;
  successMessage: string;
  tooltip: string;
  icon?: ComponentType<SVGProps<SVGSVGElement>>;
  'data-testid'?: string;
}

export const CopyChip = ({
  copyValue,
  label,
  successMessage,
  tooltip,
  icon: Icon = CopyLinear,
  'data-testid': testId,
}: CopyChipProps) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <Button
        type="button"
        variant="outline"
        size="sm"
        className="h-6 gap-1 px-2 text-xs tabular-nums"
        onClick={() => {
          writeToClipboardPolyfill(copyValue);
          toast.success(successMessage);
        }}
        data-testid={testId}
      >
        <span className="truncate">{label}</span>
        <Icon aria-hidden className="size-3.5 shrink-0" />
      </Button>
    </TooltipTrigger>
    <TooltipContent>{tooltip}</TooltipContent>
  </Tooltip>
);
